/* eslint-disable */
import React from 'react';
import { Col, DatePicker, Form, Input, Row } from 'antd';

import dayjs from 'dayjs';
// import { generalLeaseConfig } from '../Configs/generalLeaseConfig';
import { constantFormValues } from '../../root';
import InputLabel from 'components/InputLabel/index';

const GeneralLeaseInformation = ({ screen = 'CREATE' }) => {
	const form = Form.useFormInstance();
	const formData = form?.getFieldsValue();
	const handleRetirementStartDateChange = (date) => {
		if (!formData?.changes?.[0]?.inputChangeEffectiveDate) return;
		form.setFieldValue(constantFormValues?.retirementTerm?.key, dayjs(date).diff(formData?.changes?.[0]?.inputChangeEffectiveDate, 'month'));
	};
	return (
		<Row gutter={[16, 0]}>
			<Form.Item noStyle name={constantFormValues?.version?.key} />
			{/* <Form.Item noStyle name={constantFormValues?.paymentModalitylabel?.key} /> */}

			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.RetirementId?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.RetirementId?.key}>
					<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col> */}
			<Col xs={4}>
				<InputLabel label={constantFormValues?.retirementCost?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.retirementCost?.key} rules={constantFormValues?.retirementCost?.rules}>
					<Input type="number" disabled={screen === 'VIEW'} placeholder="Retirement Cost" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.retirementStartDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.retirementStartDate?.key} rules={constantFormValues?.retirementStartDate?.rules}>
					<DatePicker
						disabled={screen === 'VIEW'}
						format="YYYY-MM-DD"
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						onChange={handleRetirementStartDateChange}
					/>
				</Form.Item>
			</Col>
			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.startYear?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.startYear?.key} rules={constantFormValues?.startYear?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Start Year" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.startMonth?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.startMonth?.key} rules={constantFormValues?.startMonth?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Start Month" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.startDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.startDate?.key} rules={constantFormValues?.startDate?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Start Date" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col> */}
			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.retirementTitle?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.retirementTitle?.key} rules={constantFormValues?.retirementTitle?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.lessorName?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.lessorName?.key} rules={constantFormValues?.lessorName?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col> */}

			<Col xs={4}>
				<InputLabel label={constantFormValues?.initialDiscountRate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.initialDiscountRate?.key} rules={constantFormValues?.initialDiscountRate?.rules}>
					<Input type="number" disabled={screen === 'VIEW'} placeholder="Discount Rate" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Form.Item noStyle name={constantFormValues?.retirementTerm?.key} />
			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.retirementTerm?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.retirementTerm?.key} rules={constantFormValues?.retirementTerm?.rules}>
					<Input
						type="number"
						disabled={screen === 'VIEW'}
						placeholder="Write here"
						style={{ height: '32px', borderRadius: '4px' }}
						// onChange={() => {
						// 	handleLeaseDateChangeD();
						// }}
					/>
				</Form.Item>
			</Col> */}
			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.inputChangeMonth?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.inputChangeMonth?.key}>
					<Input
						type="number"
						disabled={screen === 'VIEW'}
						placeholder="Input Change Month"
						style={{ height: '32px', borderRadius: '4px' }}
					/>
				</Form.Item>
			</Col> */}
			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.leaseEndDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseEndDate?.key} rules={constantFormValues?.leaseEndDate?.rules}>
					<DatePicker disabled style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Form.Item noStyle name={constantFormValues?.paymentModality?.key} />
			{screen !== 'CREATE' && (
				<>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.creationDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item name={constantFormValues?.creationDate?.key}>
							<DatePicker
								type="date"
								disabled={screen === 'VIEW' || screen === 'EDIT' || screen === 'REVISE'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							/>
						</Form.Item>
					</Col>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.lastModifiedDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item
							name={constantFormValues?.lastModifiedDate?.key}
							initialValue={statusData?.lastModifiedDate ? dayjs(statusData?.lastModifiedDate) : null}
						>
							<DatePicker
								disabled={screen === 'VIEW' || screen === 'EDIT' || screen === 'REVISE'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								showTime={false}
							/>
						</Form.Item>
					</Col>
				</>
			)} */}
		</Row>
	);
};

export default GeneralLeaseInformation;
